import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { InPageNotification } from "@ebsco-ui/ebsco-ui";
import { injectIntl, FormattedMessage } from "react-intl";
import messages from "./consent-date-notification-messages";

import "./consent-date-notification.scss";
import { getConsentDateTime } from "../../../store/consent-date";

const ConsentDateNotificationWithFlagOn = ({
  consentDate,
  intl: { formatDate }
}) => {
  return consentDate ? (
    <InPageNotification
      variant="information"
      className="consent-date-notification"
      ariaLabel="Consent Date Notification"
    >
      <InPageNotification.Description>
        <FormattedMessage
          {...messages.consentDate}
          values={{
            consentDateTime: formatDate(consentDate, {
              month: "2-digit",
              day: "2-digit",
              year: "numeric"
            })
          }}
        />
      </InPageNotification.Description>
    </InPageNotification>
  ) : null;
};

ConsentDateNotificationWithFlagOn.propTypes = {
  consentDate: PropTypes.string
};

const mapStateToProps = state => ({
  consentDate: getConsentDateTime(state)
});

export { ConsentDateNotificationWithFlagOn };
export default compose(
  injectIntl,
  connect(mapStateToProps)
)(ConsentDateNotificationWithFlagOn);
